import { render, staticRenderFns } from "./NewParto.vue?vue&type=template&id=606c9360"
import script from "./NewParto.vue?vue&type=script&lang=js"
export * from "./NewParto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports